import { HUBSPOT, TWILIO } from 'calling-internal-common/call-provider/constants/ProviderNames';
import { getProviderFromLocalStorage } from 'calling-internal-common/utils/getProviderFromLocalStorage';
const HUBSPOT_PROVIDER = {
  name: HUBSPOT,
  supportsCustomObjects: true,
  supportsInboundCalling: true,
  supportsChannelConnection: false,
  usesCallingWindow: true
};
const TWILIO_PROVIDER = {
  name: TWILIO,
  supportsCustomObjects: true,
  supportsInboundCalling: true,
  supportsChannelConnection: false,
  usesCallingWindow: true
};
export const getInstalledCallingSettings = ({
  installedCallingSettings,
  hasTwilioConnect
}) => {
  const firstPartyCallingProviders = [HUBSPOT_PROVIDER];
  if (hasTwilioConnect) {
    firstPartyCallingProviders.push(TWILIO_PROVIDER);
  }
  const installedCallingApplications = installedCallingSettings.result.results || [];
  const thirdPartyCallingProviders = installedCallingApplications.filter(app => Boolean(app.isReady && app.name));
  const providerFromLocalStorage = getProviderFromLocalStorage();
  if (providerFromLocalStorage) {
    thirdPartyCallingProviders.push(providerFromLocalStorage);
  }
  return firstPartyCallingProviders.concat(thirdPartyCallingProviders);
};